import React, { useEffect, useMemo, useRef } from "react";
import { AgGridReact } from "ag-grid-react";
import { ModuleRegistry, AllCommunityModule } from "ag-grid-community";

ModuleRegistry.registerModules([AllCommunityModule]);

export default function AppDataGrid({
  rowData = [],
  columnDefs = [],
  loading = false,
  height = 420,
  minWidth = 900,
  className = "",
  defaultColDef,
  gridRef,
  onGridReady,
  onSortChanged,
  rowHeight = 42,
  headerHeight = 38,
  overlayLoadingTemplate = '<span class="ag-overlay-loading-center">Loading data...</span>',
  overlayNoRowsTemplate = '<span class="ag-overlay-loading-center">No records found.</span>',
  ...rest
}) {
  const apiRef = useRef(null);

  const overlayLoading = overlayLoadingTemplate;
  const overlayNoRows =
    overlayNoRowsTemplate ||
    '<span class="ag-overlay-no-rows-center">No records found.</span>';

  const mergedDefaultColDef = useMemo(
    () => ({
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: false,
      minWidth: 90,
      cellClass: "text-sm text-left",
      headerClass: "text-left",
      cellStyle: {
        userSelect: "text",
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        paddingLeft: 10,
        paddingRight: 10,
      },
      ...(defaultColDef || {}),
    }),
    [defaultColDef]
  );

  const handleGridReady = (params) => {
    apiRef.current = params.api;
    if (gridRef) gridRef.current = params.api;
    onGridReady?.(params);
  };

  useEffect(() => {
    const api = apiRef.current || gridRef?.current;
    if (!api) return;
    if (loading) {
      api.showLoadingOverlay?.();
      return;
    }
    if (!rowData || rowData.length === 0) {
      api.showNoRowsOverlay?.();
      return;
    }
    api.hideOverlay?.();
  }, [loading, rowData, gridRef]);

  return (
    <div className={`ag-theme-alpine app-data-grid ${className}`} style={{ height, minWidth }}>
      <AgGridReact
        rowData={rowData}
        columnDefs={columnDefs}
        defaultColDef={mergedDefaultColDef}
        animateRows={true}
        suppressRowClickSelection={true}
        enableCellTextSelection={true}
        rowHeight={rowHeight}
        headerHeight={headerHeight}
        onGridReady={handleGridReady}
        onSortChanged={onSortChanged}
        overlayLoadingTemplate={overlayLoadingTemplate}
        overlayNoRowsTemplate={overlayNoRows}
        {...rest}
      />
    </div>
  );
}
